import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-decision-buttons',
    templateUrl: './decision-buttons.component.html',
    styleUrls: ['./decision-buttons.component.scss'],
    standalone: false
})
export class DecisionButtonsComponent {
  @Output() decisionSelected = new EventEmitter<'profile' | 'library' | 'exchange' | 'images-sending' | 'images-retrieving' | 'documents-exchange'>();

  onDecisionSelected(option: 'profile' | 'library' | 'exchange' | 'images-sending' | 'images-retrieving' | 'documents-exchange'): void {
    this.decisionSelected.emit(option);
  }
}
